var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:!_vm.darkTheme ? 'light-theme' : 'dark-theme',attrs:{"id":"footer"}},[_c('div',{staticClass:"footContent"},[_vm._v("\n    © 2021 Simone Franza\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }